import React from 'react';
import ExportAgricolaPaso7 from './agricola/ExportAgricolaPaso7';
import ExportPecuarioPaso7 from './pecuario/ExportPecuarioPaso7';
import ExportServicioPaso7 from './servicios/ExportServicioPaso7';

const ExportPaso7 = ({ formData, styles }) => {
    if (formData?.lineaProductiva === 'Servicios') {
        return <ExportServicioPaso7 formData={formData} styles={styles} />;
    }

    if (formData?.lineaProductiva === 'Agrícola') {
        return <ExportAgricolaPaso7 formData={formData} styles={styles} />;
    }

    if (formData?.lineaProductiva === 'Pecuaria') {
        return <ExportPecuarioPaso7 formData={formData} styles={styles} />;

    }

    return null; // Manejo del caso en que ninguna condición se cumpla
};

export default ExportPaso7;
